import { render } from "./ContactConfirm.vue?vue&type=template&id=5de1ee6c"
import script from "./ContactConfirm.vue?vue&type=script&lang=js"
export * from "./ContactConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__